import * as Factory from 'factory.ts'
import faker from 'faker'

import { type AuditLogChangedFieldApiModel } from '../AuditLogChangedFieldApiModel'

export const AuditLogChangedFieldApiModelStub =
  Factory.Sync.makeFactory<AuditLogChangedFieldApiModel>({
    item: Factory.each(() => faker.lorem.sentence()),
    field: Factory.each(() => faker.random.word()),
    from: Factory.each(() => faker.commerce.price()),
    to: Factory.each(() => faker.commerce.price()),
  })
